<template>
  <div>
    <div class="d-flex p-2 gap-2">
      <div class="d-flex flex-column">
        <outdated-info
          :real="departure.time.format('HH:mm')"
          :planned="departure.plannedTime?.format('HH:mm')"
        ></outdated-info>
      </div>
      -
      <div class="d-flex flex-column">
        <outdated-info
          :real="arrival.time.format('HH:mm')"
          :planned="arrival.plannedTime?.format('HH:mm')"
        ></outdated-info>
      </div>
      |
      <div class="d-flex flex-column">
        <time-duration
          :duration="summary.duration"
          :plannedDuration="summary.plannedDuration"
        ></time-duration>
      </div>
      |
      <div>{{ summary.transfers }} Umst.</div>
    </div>

    <products-durations
      class="p-2"
      :summaries="summary.journeySegmentSummaries"
    ></products-durations>

    <div class="d-flex p-2 gap-2">
      <div class="d-flex gap-2 flex-sm-row flex-column">
        <TransferScore class="btn border rounded" :score="summary.connectionScore"></TransferScore>
        <ArrivalScore
          class="btn border rounded"
          :prediction="lastLeg.arrivalDelayPrediction"
          :arrivalTime="lastLeg.arrival"
        ></ArrivalScore>
      </div>
      <div class="d-flex gap-2 flex-sm-row flex-column flex-grow-1">
        <BuyTicketButton
          class="flex-fill"
          :datetime="departure.time"
          :price="journey.price"
          :start="journey.legs[0].origin.name"
          :destination="journey.legs.at(-1).destination.name"
          :refreshToken="journey.refreshToken"
        ></BuyTicketButton>
        <div class="flex-fill d-flex gap-2">
          <ShareButton class="flex-grow-1" :journey="journey"></ShareButton>
          <save-journey-button class="flex-grow-1" :journey="journey"></save-journey-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BuyTicketButton from '~/components/JourneyDisplay/BuyTicketButton.vue'
import { type Journey } from '~/types/fptfTypes'
import OutdatedInfo from '~/components/OutdatedInfo.vue'
import { getJourneySummary, getJourneyDeparture, getJourneyArrival } from '~/utils/fptfHelpers'
import TimeDuration from '~/components/TimeDuration.vue'
import ProductsDurations from '~/components/JourneyDisplay/ProductsDurations.vue'
import SaveJourneyButton from '~/components/JourneyDisplay/SaveJourneyButton.vue'
import TransferScore from '~/components/JourneyDisplay/TransferScore.vue'
import ShareButton from '~/components/JourneyDisplay/ShareButton.vue'
import ArrivalScore from './ArrivalScore.vue'
import { type Leg } from '~/types/fptfTypes'

const props = defineProps<{
  journey: Journey
}>()

const summary = computed(() => {
  return getJourneySummary(props.journey)
})
const departure = computed(() => {
  return getJourneyDeparture(props.journey)
})
const arrival = computed(() => {
  return getJourneyArrival(props.journey)
})

const lastLeg = computed(() => {
  return props.journey.legs.filter((leg) => leg.type === 'leg').slice(-1)[0] as Leg
})
</script>
